/**
 * @typedef {string} IntegrationType
 **/

/**
 * Fx. used to tell the iframes about the context in which it was triggered
 * - through data_from_source.integrationType
 */
enum IntegrationTypes {
  ENGAGEMENT_WIDGET = "engagement-widget",
  CONTACT_WIDGET = "contact-widget",
  FLOATING_ACTION_BUTTON = "floating-action-button",
  STANDALONE_PROMPTS = "standalone-prompts",
  WIDGET_ROUTER = "widget-router",
  TRADE_IN_INLINE_BUTTON = "default-widget-button",
  TEST_DRIVE_INLINE_BUTTON = "test-drive-inline-button",
  TEST_DRIVE_BANNER = "test-drive-banner",
  TRADE_IN_INLINE_FORM = "inline-form",
  TEST_DRIVE_INLINE_FORM = "test-drive-inline-form",
  CONVERSION_BOX = "conversion-box",
  GET_BETTER_PRICE_FLOW = "get-better-price-flow", // RETIRED
  CUSTOM = "custom",
  PRICE_ALERT_INLINE_BUTTON = "price-alert-inline-button",
  PRICE_ALERT_WIDGET = "price-alert-widget",
  // Whenever we have a CTA button from a flow to another
  CROSS_FLOW_CTA = "cross-flow-cta",
  INSIGHTS_VIEW = "insights-view",
}

export default IntegrationTypes
